import useGetApi from '@/api/useGetApi';

interface RexelShipAndDebitStats {
  transactionCount: number;
  totalDebitAmount: number;
  vendorCount: number;
}

export const useRexelShipAndDebitStats = () => {
  return useGetApi<RexelShipAndDebitStats>({
    endpoint: 'rexel/ship-and-debit/844/stats',
  });
};
